import { iconSizes } from '@/theme/tokens';
import { Box, CircularProgress, Stack, Text } from '@/ui';
import type { ReactElement } from 'react';

type SettingsPageLoadingStateProps = {
  message: string;
};

export const SettingsPageLoadingState = ({
  message,
}: SettingsPageLoadingStateProps): ReactElement => (
  <Box
    sx={{
      minHeight: '45vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack gap="md" align="center">
      <Text role="body" color="textSecondary" align="center">
        {message}
      </Text>
      <CircularProgress size={iconSizes.lg} />
    </Stack>
  </Box>
);
